
export const SET_NEW_CLINIC_LIST= "SET_NEW_CLINIC_LIST";
export const SET_NEW_CLINIC_LIST_CLEAR = "SET_NEW_CLINIC_LIST_CLEAR";
export const SET_NEW_CLIENT_LIST= "SET_NEW_CLIENT_LIST";
export const SET_NEW_CLIENT_LIST_CLEAR = "SET_NEW_CLIENT_LIST_CLEAR"